import { ConfiguratorProvider } from './context/ConfiguratorContext';
import ConfiguratorViewer from './components/ConfiguratorViewer/ConfiguratorViewer';
import ConfiguratorSelector from './components/ConfiguratorSelector/ConfiguratorSelector';
import LanguageSelector from './components/LanguageSelector/LanguageSelector';
import MetaTags from './components/MetaTags/MetaTags';
import './App.scss';

function App() {

  return (
    <ConfiguratorProvider>
      <div className="App">
        {/* MetaTags component manages dynamic OG meta tags */}
        <MetaTags />
        <ConfiguratorSelector />
        <ConfiguratorViewer />
        <LanguageSelector />
      </div>
    </ConfiguratorProvider>
  );
}

export default App;
